const CS_FP_SRC = 'https://device.clearsale.com.br/p/fp.js';

export const getOrCreateClearSaleSessionId = () => {
  const KEY = 'clearsale_session_id';
  let sid = localStorage.getItem(KEY);
  if (!sid) {
    sid = `${Date.now()}-${Math.floor(Math.random() * 1e9)}`;
    localStorage.setItem(KEY, sid);
  }
  return sid;
};

const ensureCsdpQueue = () => {
  if (!window.csdp) {
    const q = [];
    const fn = (...args) => q.push(args);
    fn.q = q;
    fn.l = Date.now();
    window.csdp = fn;
  }
};

const ensureClearSaleFpScript = () =>
  new Promise(resolve => {
    const existing = document.querySelector(`script[src="${CS_FP_SRC}"]`);
    if (existing) {
      resolve(true);
      return;
    }

    const s = document.createElement('script');
    s.async = true;
    s.src = CS_FP_SRC;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

export const loadClearSaleFingerprint = async (app, sessionId) => {
  if (!app || !sessionId) return;

  if (window.__CS_FP_INIT__) return;
  window.__CS_FP_INIT__ = true;

  ensureCsdpQueue();
  const ok = await ensureClearSaleFpScript();
  if (!ok) return;

  window.csdp('app', app);
  window.csdp('sessionid', sessionId);

  // ping opcional para facilitar homologação
  try {
    const img = new Image();
    img.src = `https://device.clearsale.com.br/p/fp.png?sid=${encodeURIComponent(
      sessionId
    )}&app=${encodeURIComponent(app)}`;
  } catch (e) {
    // noop
  }
};
